var api = {};
api.install = function(Vue) {
    if (api.installed) {
        return;
    }
    api.installed = true;
    Vue.prototype.$api = {
        system: {
            moduleList: "/api/module/list",
            module: "/api/module",
            moduleByUser: "/api/module/byuser",
            moduleForDownList: "/api/module/downlist",
            moduleOnlyparent: "/api/module/onlyparent",
            moduleTree: "/api/module/tree",
            role: "api/role",
            roleList: "api/role/list",
            roleDownList: "api/role/downlist",
            roleFunctions: "/api/role/function",
            function: "/api/function",
            functionList: "/api/function/list",
            functionsByModuleCode: "/api/Function/bymodulecode",
            userList: "api/user/list",
            user: "api/user",
            downlistall: "api/Site/downlistall", //为下拉提供站点列表(无权限控制)
            userishaveUA: "api/user/ishaveUA",
            userResetpwd: "/api/user/resetPwd",
            userall: "api/User/getalluser",
            changepwd: "api/user/updatepwd",
            getcustom: "/api/User/getcustominfo",
            putcustom: "/api/User/custom"
        },
        base: {
            getcode: "/api/Login/verification",
            login: "api/Login",
            loginout: "/api/login/out",
            gettypelist: "/internal/base/getTypeList",
            getstatuslist: "/internal/base/getStatusList"
        },
        lightbox: {
            getLightbox: "api/lightbox/list",
            LightBoxLog: "/api/lightboxLog/list",
            LightBoxLogNew: "/api/lightboxLog/lightboxlog",
            DelLightbox: "/api/lightbox", //删除灯箱信息
            AddLightbox: "/api/LightBox", //增加,修改灯箱信息
            checkLightboxcode: "/api/lightbox/checkcode", //判断灯箱编号是否重复
            lightboxDevice: "/api/Device/lightbox", //根据灯箱ID获取设备列表
            tree: "/api/lightbox/LBTree",
            getLightboxnew: "api/lightbox/listnew",
        },
        device: {
            getdeviceList: "/api/Device/new",
            getdevicebysiteid: "api/device/getbysiteid/",
            autoCreate: "/api/Device/AutoCreate", //自动生成设备数据
            delDevice: "/api/Device/", //删除设备信息
            addDevice: "/api/Device", //增加,修改设备信息
            getNoDevice: "/api/lightbox/downlist/NoDevice", //灯箱下拉
            checkcode: "/api/Device/checkcode", //设备nickcode唯一
            getdevicebynolightbox: "/api/Device/getnocurrentlightbox",
            updatelightboxdevice: "/api/Device/updatelightbox",
            binduser: "/api/Device/binduser",
            config: "api/Device/config",
            GetDeviceUserList: "/api/Device/gerusersbydevicecode/",
            unbinduser: "/api/Device/unbinduser",
            unbindLightBox: "/api/Device/unbindLightBox",
            unbindusers:"/api/Device/unbindusers"
        },
        Version: {
            getVersion: "/api/Version", //版本列表
            getdownlist: "/api/Version/downlist", //版本列表下拉
            select: "/api/DeviceVersion/select", //版本已绑定的设备列表
            unselected: "/api/DeviceVersion/unselected", //版本未绑定的设备列表
            binddevice: "/api/DeviceVersion", //绑定设备
            postall: "/api/DeviceVersion/postall", //绑定所有设备
            sendorder: "/api/DeviceVersion/sendorder", //发送更新预备指令
            sendorderall: "/api/DeviceVersion/sendorderall", //根据版本ID发送更新预备指令
        },
        AD: {
            getAD: "/api/AD",
            getAdvertiser: "/api/Advertiser/downlist", //广告商下拉
            getAdLightBox: "/api/lightbox/downlist", //灯箱下拉
            DelAD: "/api/AD", //删除广告信息
            postAndcard: "/api/AD/andcard", //绑定卡片
        },
        Bindcard: {
            unselected: "/api/ADDevice/unselected", //广告未绑定的设备列表
            selected: "/api/ADDevice/selected", //广告已绑定的设备列表
            addevice: "/api/ADDevice", //广告绑定设备,返回带绑定
            cardcode: "/api/ADDevice/cardcode", //绑定卡片
            cardcodebatch: "/api/ADDevice/cardcodebatch", //批量绑定卡片
        },
        Advertiser: {
            getAdvertiser: "/api/Advertiser", //查询、增加、修改广告商
            DelAdvertiser: "/api/Advertiser"
        },
        Order: {
            api: "/api/order",
            getorderlist: "/api/Order/new",
            del: "/api/order/del",
            export: "/api/Order/export"
        },
        OrderTemp: {
            api: "/api/OrderTemp",
            pass: "/api/OrderTemp/pass", //审核预备指令
            send: "/api/OrderTemp/send", //发送预备指令
            reject: "/api/OrderTemp/reject" //驳回预备指令
        },
        realdata: {
            getrealdatalist: "/api/Realdata/new",
            getOneDate: "/api/Realdata/OneDate",
            forlog: "/api/Realdata/forlog"
        },
        site: {
            api: "/api/Site",
            DelSite: "/api/Site", //删除站点信息
            AddSite: "/api/Site", //增加,修改站点信息
            downlist: "/api/site/downlist", //站点下拉
            all: "/api/site/all",
            statistics: "/api/site/statistics/",
            report: "/api/Site/Report/"
        },
        advertiser: {
            api: "/api/advertiser",
            downlist: "/api/advertiser/downlist"
        },
        card: {
            getCard: "/api/Card", //查询、生成卡片
            getSupplier: "/api/Card/supplier",
            getBatch: "/api/Card/batch",
            getBatchNew: "/api/Card/batch/new", //生成新的批次号
            getExport: "/api/Card/export", //导出
            getSearch: "/api/Card/search/" //根据卡号查询卡信息
        },
        MultiflowData: {
            getMFDbyDeviceCode: "/api/MultiflowData/mdfbydevicecode",
            getData: "/api/MultiflowData"
        },
        MultiflowType: {
            getMultiflowType: "/api/MultiflowType",
        },
        Alert: {
            api: "/api/Alert",
            sendlog: "/api/AlertSendLog",
            sendLogExport:"/api/AlertSendLog/export"
        },
        AlertConfig: {
            api: "/api/alertconfig",
            downlist: "/api/AlertConfig/downlist",
            downlistmtype: "/api/AlertConfig/downlist/getmtypecode"
        },
        AlertUser: {
            api: "/api/AlertUser",
            Tree: "/api/AlertUser/Tree",
            ByConfigId: "/api/AlertUser/config/"
        },
        DeviceCheckUpLog: {
            api: "/api/DeviceCheckUpLog"
        },
        Log: {
            api: "/api/Log",
            WorkTime:"/api/Log/worktime",
            ExporWorkTime:"/api/Log/worktime/export",
        }
    }
}
export default api